module.exports = __webpack_public_path__ + "img/shape-content-contact-mobiel.54526932b788a2bc39c3081d0ca9fdb0.svg";